module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/october-786deaa09cc513896c483604a5bab7ad.png";